<div class="replace-card-content pointer-events-none" *ngIf="!isSeparateZone; else separateZoneTemplate">
  <div
    class="widget-box"
    (click)="openReplaceCardPopup()"
    [ngClass]="{
      'is-workflow': isWorkflow,
      'disable-widget': !isWidgetEnabled
    }"
  >
    <div class="widget-icon" [ngStyle]="borderStyle">
      <mat-icon class="replace-card" svgIcon="replace-card"></mat-icon>
    </div>
    <label for="title" class="label" [ngStyle]="textContentStyle" [ngClass]="{ 'is-workflow': isWorkflow }">
      Replace Card
    </label>
  </div>
</div>

<ng-template #separateZoneTemplate>
  <div
    class="replace-card-content separate-zone pointer-events-none"
    [ngStyle]="contentStyle"
    style="height: 98%"
    [ngClass]="{
      'disable-widget': !isWidgetEnabled
    }"
  >
    <div class="list-box" (click)="openReplaceCardPopup()">
      <div class="l-section">
        <div class="image">
          <mat-icon class="replace-card" svgIcon="replace-card"></mat-icon>
        </div>
      </div>
      <div class="center-section" style="width: 100%">
        <div class="title">Replace Card</div>
        <div class="sub-title">Replace your card and issue a new one</div>
      </div>
    </div>
  </div>
</ng-template>
